export const watchSecretsStatus = (connection, sessionid, update) => {
  let revision = 0;
  let disposed = false;
  const check = async () => {
    const request = ++revision;
    update(false);
    if (!connection.connected) return;
    try {
      const reply = await connection.emit({ type: "secrets", action: "status", sessionid });
      if (!disposed && request === revision && !reply.error) update(reply);
    } catch {
      // Keep remote panels unmounted until status can be checked again.
    }
  };
  const onConnection = () => check();
  const onSecrets = (reply) => {
    if (disposed || !connection.connected || reply.error || typeof reply.locked !== "boolean") return;
    revision++;
    update(reply);
  };
  connection.on("connection", onConnection);
  connection.on("secrets", onSecrets);
  check();
  return () => {
    disposed = true;
    revision++;
    connection.off("connection", onConnection);
    connection.off("secrets", onSecrets);
  };
};

export default (...args) => watchSecretsStatus(...args);
